// removed by extract-text-webpack-plugin
module.exports = {"cluster":"index__cluster___3p6QT","digits":"index__digits___2hs3B","critFacPoint":"index__critFacPoint___3RcAA"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 267
// module chunks = 0